// See: https://github.com/petkaantonov/bluebird#for-library-authors
module.exports = require("bluebird/js/main/promise")();



//////////////////
// WEBPACK FOOTER
// ./node_modules/request-promise/lib/bluebird-fresh.js
// module id = 429
// module chunks = 0